export default __webpack_public_path__ + "static/media/timeline.0baafc9b.jpg";